














import Vue from 'vue'
import moment from 'moment-timezone'
import Tenant from '@/types/Tenant.interface'
export default Vue.extend({
    props: {
        //  Determines if the 'app-dialog' is closed when the submit button is used
        autoClose: {
            type: Boolean,
            default: false
        },
        //  Determines if the tenant is auto updated when a the submit button is used
        autoUpdate: {
            type: Boolean,
            default: false
        },
        //  Applies the 'outlined' style to the v-select
        outlined: {
            type: Boolean,
            default: false
        },
        //  Applies the 'solo' style to the v-select
        solo: {
            type: Boolean,
            default: false
        }
    },
    data: () => {
        return {
            loading: false,
            selected: null,
            timezones: [
                {
                    code: 'Pacific/Honolulu',
                    text: 'Hawaii Standard Time (HST)'
                },
                {
                    code: 'America/Los_Angeles',
                    text: 'Pacific Time (PT)'
                },
                {
                    code: 'America/Denver',
                    text: 'Mountain Time (MT)'
                },
                {
                    code: 'America/Phoenix',
                    text: 'Mountain Standard Time (AZ/MST)'
                },
                {
                    code: 'America/Chicago',
                    text: 'Central Time (CT)'
                },
                {
                    code: 'America/New_York',
                    text: 'Eastern Time (ET)'
                },
                {
                    code: 'America/Anchorage',
                    text: 'Alaska (AKT)'
                },
                {
                    code: 'America/Puerto_Rico',
                    text: 'Puerto Rico (Follows Daylight Savings)'
                },
                {
                    code: 'Canada/Atlantic',
                    text: 'Atlantic Standard Time (AST)'
                }
            ]
        }
    },
    mounted() {
        //  Check if a tenant is set
        if (this.tenant) {
            //  Check if the tenant already has a timezone set
            let timezone = this.tenant.default_timezone

            //  If the timezone exists, set the form's selecetedTimezone
            if (timezone) this.selected = this.timezones.find((x) => x.code === timezone)
        }

        //  If no 'selected' is set yet, lets try to guess
        if (!this.selected) {
            //  Try to guess the user's timezone
            const guess = moment.tz.guess()

            //  If a guess exists, set the form's selected to the guess
            if (guess) this.selected = this.timezones.find((x) => x.code === guess)
        }
    },
    computed: {
        tenant(): Tenant {
            return this.$store.getters.tenant
        }
    },
    methods: {
        submit(): void {
            //  If the tenant is set to auto-update, update the tenant
            if (this.autoUpdate) return this.tenantUpdateTimezone()

            //  Else, emit the selected timezone to the parent component (we use 'submit' incase the component is hosted in DialogApp.vue)
            this.$emit('submit', this.selected.code)
        },
        async tenantUpdateTimezone(): Promise<void> {
            //  If the tenant does NOT exist, do nothing
            if (!this.tenant) return

            //  Assemble the request payload
            const payload = {
                id: this.tenant.id,
                default_timezone: this.selected.code
            }

            //  Start the loading spinner
            this.loading = true

            //  Send the update request to  the API
            const tenant = await this.$store.dispatch('tenantPut', payload)

            //  Stop the loading spinner
            this.loading = false

            //  If the request failed, do nothing
            if (!tenant) return

            //  If the 'autoClose' prop is set true, close the app-dialog
            if (this.autoClose) return this.$store.dispatch('dialogClose', 'APP')

            //  Emit updated tenant to parent component (we use 'submit' incase the component is hosted in DialogApp.vue)
            this.$emit('submit', tenant)
        }
    }
})
